import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { normalizeStandardWorkDayHours } from '@shared/labour-costing';

export function useStandardWorkDayHours(): number {
  const { data } = useQuery({
    queryKey: ['settings', 'default_shift_hours'],
    queryFn: async () => {
      const response = await api.get<any>('/settings/default_shift_hours');
      return response.data;
    },
    staleTime: 5 * 60_000,
    retry: 0,
  });
  return normalizeStandardWorkDayHours((data as any)?.value);
}
